import React from 'react';
import classes from './NavItems.css';
import NavItem from './NavItem/NavItem';

const NavItems=(props)=>(

	<ul className= {classes.NavItems}>
		<NavItem link="/" >Burger Builder</NavItem>
		{props.isAuth?<NavItem link="/orders" >Orders</NavItem>: null}
   {!props.isAuth? <NavItem link="/auth" >Authenticate</NavItem>:
    <NavItem link="/logout" >Log Out</NavItem>}
	</ul>

	)

export default NavItems;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavItems/NavItems.jsx